module.exports = __webpack_public_path__ + "assets/images/f891a013f4403b4754ef023cf45ab4e9.png";